import { useTranslations } from "@jugl-web/utils";
import { LoadingAnimation, BottomCenteredDrawer } from "@jugl-web/ui-kit";
import { ReactComponent as TitleIcon } from "./assets/title-icon.svg";
import { BoardTemplatesModalProvider } from "./providers/BoardTemplatesModalProvider";
import { useBoardTemplatesModalProvider } from "./providers/useBoardTemplatesModalProvider";
import { BoardTemplatesLayout } from "./components/BoardTemplatesLayout/BoardTemplatesLayout";
import { BoardCategoryTemplatesList } from "./components/BoardCategoryTemplatesList/BoardCategoryTemplatesList";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const BoardTemplatesModalContent = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslations();
  const { setSelectedCategory, isCreatingBoardInProgress } =
    useBoardTemplatesModalProvider();
  const handleClose = () => {
    onClose();
    setTimeout(() => {
      setSelectedCategory("popular-templates");
    }, 400);
  };
  return (
    <BottomCenteredDrawer
      className="w-[1824px] max-w-[min(1824px,95vw)]"
      header={{
        type: "title",
        title: (
          <div className="flex items-center justify-center gap-3">
            <TitleIcon />
            {t({
              id: "board-templates-drawer.title",
              defaultMessage: "Board Templates",
            })}
          </div>
        ),
      }}
      isOpen={isOpen}
      onClose={handleClose}
    >
      {isCreatingBoardInProgress && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="absolute inset-0 z-10 backdrop-blur-[1px] dark:bg-[rgba(14,14,14,0.56)]" />
          <div className="relative z-20">
            <LoadingAnimation />
          </div>
        </div>
      )}
      <BoardTemplatesLayout>
        <BoardCategoryTemplatesList />
      </BoardTemplatesLayout>
    </BottomCenteredDrawer>
  );
};

export const BoardTemplatesModal = ({
  isOpen,
  entityId,
  onUseTemplateSuccess,
  onClose,
}: Props & {
  entityId: string;
  onUseTemplateSuccess: (id: string) => void;
}) => (
  <BoardTemplatesModalProvider
    entityId={entityId}
    onUseTemplateSuccess={onUseTemplateSuccess}
    onClose={onClose}
  >
    <BoardTemplatesModalContent isOpen={isOpen} onClose={onClose} />
  </BoardTemplatesModalProvider>
);
